module.exports = __webpack_public_path__ + "static/media/sidebar-supervisor-selected.6a843a1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-supervisor-selected.svg
// module id = 804
// module chunks = 0